module.exports = "pegasus_template/assets/preview-9.png";